import { Unit } from './unit';
import { unitsDictionary } from './units-dictionary';

type TUnitElement = [string] | [string, string, number, number, number, number];

export class UnitManager {
  units = new Map<string, Unit>();

  quantities = new Map<string, string[]>();

  constructor() {
    this.loadUnits(unitsDictionary);
  }

  addUnit(symbol: string, baseUnit: string, a: number, b: number, c: number, d: number): void;
  addUnit(symbol: string): void;
  addUnit(symbol: string, base?: string, a?: number, b?: number, c?: number, d?: number) {
    if (base != null && a != null && b != null && c != null && d != null) {
      this.units.set(symbol, new Unit(symbol, base, a, b, c, d));
    } else {
      this.units.set(symbol, new Unit(symbol, symbol, 0, 1, 1, 0));
    }
  }

  convert(fromUnit: Unit, toUnit: Unit, value: number): number;
  convert(fromUnitSymbol: string, toUnitSymbol: string, value: number): number;
  convert(from: string | Unit, to: string | Unit, value: number): number {
    if (typeof from === 'string' && typeof to === 'string') {
      const fromUnit = this.units.get(from);
      const toUnit = this.units.get(to);

      return fromUnit != null && toUnit != null ? this.convert(fromUnit, toUnit, value) : value;
    }
    if (typeof from === 'object' && typeof to === 'object') {
      const baseValue = from.toBase(value);
      return to.fromBase(baseValue);
    }
    return value;
  }

  loadUnits(units: TUnitElement[]) {
    units.forEach((unit) => {
      const [symbol, base, a, b, c, d] = unit;
      if (base != null && a != null && b != null && c != null && d != null) {
        this.addUnit(symbol, base, a, b, c, d);
        const list = this.quantities.get(base) ?? [];
        this.quantities.set(base, list.concat(symbol));
      } else {
        this.addUnit(symbol);
      }
    });
  }
}
